import * as Yup from 'yup';
import { DataLists } from '../../services/data/data.types';
import { FormErrorMessages, nameSchema } from 'utils/formValidation';

export const PartnerFormSchema = (datalists: DataLists) =>
    Yup.object().shape({
        category_id: Yup.number()
            .required(FormErrorMessages.required)
            .test('is-valid-category', FormErrorMessages.category_invalid, function (value) {
                return value !== 0;
            }),
        name: nameSchema,
        firstname: Yup.string().min(3, FormErrorMessages.min_characters).max(50, FormErrorMessages.max_characters).optional(),
        lastname: Yup.string().min(3, FormErrorMessages.min_characters).max(50, FormErrorMessages.max_characters).optional(),
        department: Yup.string()
            .oneOf(Object.keys(datalists?.departments || {}), FormErrorMessages.department_invalid)
            .optional(),
        phone: Yup.string()
            .matches(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/, FormErrorMessages.phone_invalid)
            .optional(),
        email: Yup.string().email(FormErrorMessages.email_invalid).optional(),
        address: Yup.object({
            address: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional(),
            address_add: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional(),
            city: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional(),
            zipcode: Yup.string()
                .matches(/^\d{5}$/, FormErrorMessages.zipcode_invalid)
                .optional(),
            country: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional()
        }).optional(),
        documents: Yup.array()
            .of(
                Yup.object({
                    id: Yup.number().required(),
                    original_filename: Yup.string()
                        .min(3, FormErrorMessages.min_characters)
                        .max(2000, FormErrorMessages.max_characters)
                        .required(),
                    level: Yup.string().oneOf(['public', 'private']).required()
                })
            )
            .optional()
    });
